import { graphql } from '@gql';

export const SET_PROJECT_USERS = graphql(`
    mutation setUsers($id: ID!, $users: [ProjectUserInput!]) {
        setProjectUsers(input: { id: $id, users: $users }) {
            user {
                id
                firstName
                lastName
            }
            role {
                id
                name
            }
        }
    }
`);

export const CREATE_PROJECT_GUIDANCE_CONFIG = graphql(`
    mutation CreateProjectGuidanceConfig(
        $name: String!
        $projectTypeID: ID!
        $standardProfileID: ID!
        $requirementsConfig: [SaveProjectGuidanceRequirementConfigInput!]
        $id: ID
    ) {
        saveProjectGuidance(
            input: {
                id: $id
                name: $name
                projectTypeID: $projectTypeID
                standardProfileID: $standardProfileID
                requirementsConfig: $requirementsConfig
            }
        ) {
            id
            name
        }
    }
`);

export const DELETE_PROJECT_GUIDANCE_CONFIG = graphql(`
    mutation DeleteProjectGuidanceConfig($id: ID!) {
        deleteProjectGuidance(id: $id) {
            id
        }
    }
`);

export const PUBLISH_PROJECT_GUIDANCE_CONFIG = graphql(`
    mutation PublishProjectGuidanceConfig($id: ID!) {
        publishProjectGuidance(id: $id) {
            id
            name
            isPublished
        }
    }
`);

export const CREATE_PROJECT = graphql(`
    mutation CreateProject(
        $name: String!
        $description: String!
        $statusID: ID!
        $milestoneID: ID!
        $typeID: ID!
        $organizationID: ID!
        $customerName: String
        $customerEmail: String
        $customerPhone: String
        $customerAddress: String
        $locationStreet: String
        $locationPostalCode: String
        $locationCity: String
        $locationCountry: String
        $plantName: String
        $plantExternalID: String
        $pointInput: PointInput
        $standardProfileIDs: [ID!]
        $countryIDs: [ID!]
        $userIDs: [ID!]
    ) {
        createProject(
            input: {
                userIDs: $userIDs
                countryIDs: $countryIDs
                name: $name
                description: $description
                organizationID: $organizationID
                statusID: $statusID
                milestoneID: $milestoneID
                typeID: $typeID
                customerName: $customerName
                customerEmail: $customerEmail
                customerPhone: $customerPhone
                customerAddress: $customerAddress
                locationStreet: $locationStreet
                locationPostalCode: $locationPostalCode
                locationCity: $locationCity
                locationCountry: $locationCountry
                plantName: $plantName
                plantExternalID: $plantExternalID
                pointInput: $pointInput
                standardProfileIDs: $standardProfileIDs
            }
        ) {
            id
            name
            description
            creator {
                id
                gid
                firstName
                lastName
                email
            }
            organization {
                id
                name
            }
            milestone {
                id
                name
            }
            status {
                id
                name
            }
            type {
                id
                name
            }
            updateTime
            createTime
            ...ProjectLocationPartial
            ...ProjectPlantPartial
            ...ProjectProfilePartial
        }
    }
`);

export const UPDATE_PROJECT = graphql(`
    mutation UpdateProject(
        $id: ID!
        $name: String
        $description: String
        $statusID: ID
        $milestoneID: ID
        $typeID: ID
        $organizationID: ID
        $customerName: String
        $customerEmail: String
        $customerPhone: String
        $customerAddress: String
        $locationStreet: String
        $locationPostalCode: String
        $locationCity: String
        $locationCountry: String
        $plantName: String
        $plantExternalID: String
        $pointInput: PointInput
        $securityResponsibleID: ID
        $countryIDs: [ID!]
    ) {
        updateProject(
            input: {
                id: $id
                countryIDs: $countryIDs
                name: $name
                description: $description
                organizationID: $organizationID
                statusID: $statusID
                milestoneID: $milestoneID
                typeID: $typeID
                customerName: $customerName
                customerEmail: $customerEmail
                customerPhone: $customerPhone
                customerAddress: $customerAddress
                locationStreet: $locationStreet
                locationPostalCode: $locationPostalCode
                locationCity: $locationCity
                locationCountry: $locationCountry
                plantName: $plantName
                plantExternalID: $plantExternalID
                pointInput: $pointInput
                securityResponsibleID: $securityResponsibleID
            }
        ) {
            id
            name
            description
            creator {
                id
                gid
                firstName
                lastName
                email
            }
            securityResponsible {
                id
                firstName
                lastName
            }
            organization {
                id
                name
            }
            milestone {
                id
                name
            }
            status {
                id
                name
            }
            type {
                id
                name
            }
            updateTime
            createTime
            ...ProjectCustomerPartial
            ...ProjectLocationPartial
            ...ProjectPlantPartial
        }
    }
`);

export const COPY_PROJECT = graphql(`
    mutation CopyProject(
        $copyInventory: Boolean!
        $copyMeasures: Boolean!
        $copyProjectZones: Boolean!
        $copyPssClassification: Boolean!
        $copyTasks: Boolean!
        $copyTRA: Boolean!
        $copyStandardProfiles: Boolean!
        $description: String!
        $id: ID!
        $name: String!
        $organizationID: ID!
        $milestoneID: ID!
        $statusID: ID!
    ) {
        copyProject(
            input: {
                copyInventory: $copyInventory
                copyMeasures: $copyMeasures
                copyProjectZones: $copyProjectZones
                copyPssClassification: $copyPssClassification
                copyTasks: $copyTasks
                copyTRA: $copyTRA
                copyStandardProfiles: $copyStandardProfiles
                description: $description
                id: $id
                name: $name
                organizationID: $organizationID
                milestoneID: $milestoneID
                statusID: $statusID
            }
        ) {
            projectID
        }
    }
`);

export const DELETE_PROJECT = graphql(`
    mutation DeleteProject($id: ID!) {
        deleteProject(id: $id) {
            id
        }
    }
`);

export const CREATE_PROJECT_ZONE = graphql(`
    mutation createProjectZone(
        $name: String!
        $description: String!
        $projectId: ID!
        $parentZoneId: ID!
        $exposureRating: ProjectZoneExposureRating!
        $standardProfileIds: [ID!]!
    ) {
        saveProjectZone(
            input: {
                name: $name
                description: $description
                projectID: $projectId
                parentZoneID: $parentZoneId
                exposureRating: $exposureRating
                standardProfileIDs: $standardProfileIds
                isInternal: true
            }
        ) {
            id
            name
        }
    }
`);

export const UPDATE_PROJECT_ZONE = graphql(`
    mutation updateProjectZone(
        $id: ID
        $name: String!
        $description: String!
        $projectId: ID!
        $parentZoneId: ID
        $exposureRating: ProjectZoneExposureRating!
        $standardProfileIds: [ID!]!
    ) {
        saveProjectZone(
            input: {
                id: $id
                name: $name
                description: $description
                projectID: $projectId
                parentZoneID: $parentZoneId
                exposureRating: $exposureRating
                standardProfileIDs: $standardProfileIds
                isInternal: true
            }
        ) {
            id
        }
    }
`);

export const DELETE_PROJECT_ZONE = graphql(`
    mutation DeleteProjectZone($id: ID!) {
        deleteProjectZone(id: $id) {
            id
        }
    }
`);

export const CREATE_PROJECT_ATTRIBUTE = graphql(`
    mutation CreateProjectAttribute(
        $projectID: ID!
        $input: [CreateProjectAttributeRawInput!]!
    ) {
        createProjectAttribute(projectID: $projectID, input: $input) {
            id
            label
            type
            sequence
        }
    }
`);

export const DELETE_PROJECT_ATTRIBUTE = graphql(`
    mutation DeleteProjectAttribute($projectID: ID!, $input: BulkIDInput!) {
        deleteProjectAttribute(projectID: $projectID, input: $input) {
            id
        }
    }
`);

export const UPDATE_PROJECT_ATTRIBUTE_SEQUENCE = graphql(`
    mutation UpdateProjectAttributeSequence(
        $projectID: ID!
        $input: [UpdateProjectAttributeSequenceRawInput!]!
    ) {
        updateProjectAttributeSequence(projectID: $projectID, input: $input) {
            id
            sequence
        }
    }
`);

export const BULK_UPDATE_PROJECT_ATTRIBUTE = graphql(`
    mutation UpdateProjectAttribute(
        $projectID: ID!
        $input: [UpdateProjectAttributeValueInput!]!
    ) {
        updateProjectAttributeValue(projectID: $projectID, input: $input) {
            id
            label
            type
            sequence
            value
        }
    }
`);
